import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'simulated.contentmap.approveAbilityConfirmation.title',
    defaultMessage: 'HABILITY APPROVED!',
  },
  subtitle: {
    id: 'simulated.contentmap.approveAbilityConfirmation.subtitle',
    defaultMessage: 'New ability successfully added!',
  },
  continue: {
    id: 'simulated.contentmap.approveAbilityConfirmation.continue',
    defaultMessage: 'Continue',
  },
});
